import React from 'react'
import PropTypes from 'prop-types'

// Components
import { graphql } from 'gatsby'
import Layout from '../components/layout'
import Seo from '../components/seo'
import Categories from '../components/categories'
import Posts from '../components/posts'
import { useCategories } from '../data/graphqlHooks'
import KnowledgeSection from '../components/KnowledgeSection'
import Path from '../components/Path'
import Pagination from '../components/Pagination'

const CategoriesT = ({ pageContext, data, location }) => {
  const allCategories = useCategories()
  const [categoryName, setCategoryName] = React.useState(null)

  React.useEffect(() => {
    setCategoryName(data.allMarkdownRemark.nodes[0].frontmatter.category.toLowerCase())
  }, [])

  // If page changed scroll to articles
  React.useEffect(() => {
    const elem = document.getElementById('categories')
    if (elem && location.state?.from === 'pagination') {
      scrollElementIntoView(elem, 'smooth')
    }
  }, [categoryName])

  const scrollElementIntoView = (element, behavior) => {
    const scrollTop = window.pageYOffset || element.scrollTop

    const finalOffset = element.getBoundingClientRect().top + scrollTop

    window.parent.scrollTo({ top: finalOffset, behavior: behavior || 'auto' })
  }

  // Pagination info
  const { tag, currentPage, numPages } = pageContext
  const isFirst = currentPage === 1
  const isLast = currentPage === numPages
  const prevPage = currentPage - 1 === 1 ? `/category/${categoryName}` : `/category/${categoryName}/${(currentPage - 1)}`
  const nextPage = `/category/${categoryName}/${(currentPage + 1)}`
  const posts = data.allMarkdownRemark.nodes

  return (
    <Layout location={data} title='siteTitle'>
      <Seo title={'Expert Plans Blog | ' + tag} />
      <div className='white-bground'>
        <KnowledgeSection />
      </div>
      <div id='categories' />
      <div className='container-section'>
        <Categories
          location={location}
          category={categoryName}
          onChange={setCategoryName}
          categories={allCategories}
        />
        <hr className='hrSimple' />
        <Path
          category={categoryName}
          page={currentPage}
        />
        <Posts posts={posts} />
        <Pagination
          isFirst={isFirst}
          isLast={isLast}
          currentPage={currentPage}
          prevPage={prevPage}
          nextPage={nextPage}
          numPages={numPages}
          categoryName={categoryName}
        />
      </div>
    </Layout>
  )
}

Categories.propTypes = {
  pageContext: PropTypes.shape({
    tag: PropTypes.string.isRequired
  }),
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            frontmatter: PropTypes.shape({
              title: PropTypes.string.isRequired
            }),
            fields: PropTypes.shape({
              slug: PropTypes.string.isRequired
            })
          })
        }).isRequired
      )
    })
  })
}

export default CategoriesT

export const pageQuery = graphql`
  query($tag: String,$limit: Int!, $skip: Int!) {
    site {
      siteMetadata {
        title
      }
    }

    allMarkdownRemark(
      limit: $limit
      skip:$skip
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { category: { in: [$tag] } } }
    ) {
        nodes {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD MMMM YYYY")
            title
            description
            category
            titleImage{
              childImageSharp {
                fluid(maxWidth: 2048, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
    }
  }
`
